<template>
  <div v-if="organizations" class="gp-content">
    <content-nav-bar>
      <a
        v-if="refresh"
        @click="refresh"
        class="level-item">
        <svgicon name="refresh" height="25" width="25"></svgicon>
      </a>
      <router-link class="level-item button add" :to="{ name: 'admin.organizations.index.create' }">
        <i class="fas fa-plus"></i>
        Create Organization
      </router-link>
    </content-nav-bar>
    <organizations-table
      v-if="organizations"
      :organizations="organizations.items">
    </organizations-table>
  </div>
</template>

<script>
import OrganizationsTable from '@/components/admin/organizations/OrganizationsTable.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';

export default {
  name: 'OrganizationsList',
  components: {
    OrganizationsTable,
    ContentNavBar,
  },
  async mounted() {
    this.refresh();
  },
  data() {
    return {
      organizations: null,
    };
  },
  methods: {
    async refresh() {
      this.organizations = await this.$store.dispatch('admin/listOrganizations');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

</style>
